// extracted by mini-css-extract-plugin
export default {"formItemCard":"yTmxNBbJStkpKaacm8OJ","formItemCard_text":"G5CkLFKz47ohhmeFMN_j","formItemCard_field":"nI0OszAfQsfUrsHr1LOQ"};